var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVanuatu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:54046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0005 16.4195C32.0005 15.7122 31.954 15.0157 31.865 14.3326H13.9134C10.6446 11.064 4.68651 5.1063 4.68676 5.1058C-1.5616 11.3542 -1.5616 21.4848 4.68676 27.7333L13.9136 18.5065H31.865C31.954 17.8233 32.0005 17.1268 32.0005 16.4195V16.4195Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9947 16.7845C31.994 16.8154 31.9933 16.8464 31.9924 16.8773C31.9932 16.8463 31.9939 16.8154 31.9947 16.7845Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9793 17.2217C31.9779 17.2522 31.9757 17.2827 31.9741 17.3132C31.9757 17.2827 31.9777 17.2522 31.9793 17.2217Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9577 17.5703C31.9545 17.6153 31.9514 17.6602 31.9478 17.705C31.9514 17.6602 31.9544 17.6153 31.9577 17.5703Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9045 14.6764C31.9104 14.7299 31.9163 14.7834 31.9216 14.837C31.9163 14.7833 31.9104 14.7299 31.9045 14.6764Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9741 15.5275C31.9758 15.558 31.9779 15.5884 31.9793 15.619C31.9778 15.5884 31.9758 15.5579 31.9741 15.5275Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9924 15.964C31.9933 15.9949 31.9939 16.0259 31.9947 16.0568C31.994 16.0258 31.9932 15.9949 31.9924 15.964Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9478 15.136C31.9514 15.1808 31.9545 15.2258 31.9577 15.2707C31.9544 15.2258 31.9514 15.1808 31.9478 15.136Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8649 14.333C31.8721 14.3878 31.8785 14.4429 31.885 14.4979C30.9354 6.56774 24.1863 0.420006 16.0004 0.420006C11.582 0.420006 7.58196 2.21094 4.68652 5.1065L13.913 14.333H31.8649V14.333Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8649 18.507H13.913L4.68652 27.7335C7.58196 30.629 11.582 32.42 16.0004 32.42C24.1863 32.42 30.9355 26.2723 31.885 18.3421C31.8785 18.397 31.872 18.4522 31.8649 18.507V18.507Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9216 18.0032C31.9163 18.0568 31.9104 18.1103 31.9045 18.1638C31.9104 18.1103 31.9164 18.0569 31.9216 18.0032Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9585 15.2704C31.9646 15.356 31.9701 15.4417 31.9747 15.5277C31.97 15.4417 31.9646 15.356 31.9585 15.2704V15.2704Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8843 14.4978C31.8915 14.5571 31.8983 14.6165 31.9047 14.676C31.8982 14.6165 31.8913 14.5571 31.8843 14.4978Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9221 14.8367C31.9319 14.936 31.9407 15.0355 31.9486 15.1355C31.9407 15.0355 31.9319 14.9359 31.9221 14.8367Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0002 16.42C32.0002 16.5417 31.9983 16.6629 31.9956 16.7838C31.9983 16.6628 32.0002 16.5416 32.0002 16.42Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9747 17.3124C31.97 17.3983 31.9645 17.4841 31.9585 17.5696C31.9645 17.4841 31.9699 17.3983 31.9747 17.3124Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9486 17.7048C31.9407 17.8046 31.9319 17.9042 31.9221 18.0035C31.9319 17.9042 31.9407 17.8046 31.9486 17.7048Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9047 18.1635C31.8983 18.223 31.8915 18.2823 31.8843 18.3417C31.8913 18.2824 31.8982 18.223 31.9047 18.1635Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9956 16.0564C31.9983 16.1774 32.0002 16.2986 32.0002 16.4202C32.0002 16.2986 31.9983 16.1774 31.9956 16.0564Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9802 15.6191C31.9858 15.7336 31.9901 15.8485 31.9933 15.9637C31.9901 15.8485 31.9859 15.7336 31.9802 15.6191Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9934 16.8769C31.9901 16.992 31.9858 17.107 31.9802 17.2215C31.986 17.1069 31.9902 16.992 31.9934 16.8769Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9853 15.7182H13.3257L3.74088 6.13484C3.43107 6.46159 3.09526 6.91784 2.88757 7.24278L12.0537 16.4138L2.87988 25.5878C3.06151 25.9109 3.45719 26.3892 3.73501 26.7004L13.3259 17.1095H31.9876C31.9975 16.8788 32.0006 16.647 32.0006 16.4139C32.0006 16.1015 31.992 15.8712 31.9853 15.7182Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.88702 19.8301V18.4899C5.2244 18.4899 6.31233 17.4018 6.31233 16.0646C6.31233 15.1184 5.54252 14.3487 4.5964 14.3487C3.95184 14.3487 3.4274 14.873 3.4274 15.5177C3.4274 15.9299 3.76271 16.2653 4.17496 16.2653C4.40796 16.2653 4.59752 16.0756 4.59752 15.8426H5.93765C5.93765 16.8147 5.1469 17.6054 4.17502 17.6054C3.02384 17.6055 2.0874 16.6688 2.0874 15.5178C2.0874 14.1343 3.21303 13.0087 4.59646 13.0087C6.28158 13.0087 7.65258 14.3797 7.65258 16.0648C7.65252 18.1408 5.96333 19.8301 3.88702 19.8301V19.8301Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:54046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.419922)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVanuatu);
export default __webpack_public_path__ + "static/media/vanuatu.57f56f9b.svg";
export { ForwardRef as ReactComponent };